import {MimeType} from "@reva/shared/mime-type";

export function createBlankPdfFile(): File {
    const encoder = new TextEncoder();
    const objects = [
        "%PDF-1.4\n",
        "1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n",
        "2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n",
        "3 0 obj\n<< /Type /Page /Parent 2 0 R /Resources << >> /MediaBox [0 0 612 792] >>\nendobj\n",
    ];
    const objectOffsets: number[] = [];
    let offset = 0;
    for (const object of objects) {
        objectOffsets.push(offset);
        offset += encoder.encode(object).length;
    }
    const xrefOffset = offset;
    const xrefEntries = objectOffsets
        .slice(1)
        .map((o) => `${String(o).padStart(10, "0")} 00000 n \n`)
        .join("");
    const trailer = `xref\n0 4\n0000000000 65535 f \n${xrefEntries}trailer\n<< /Size 4 /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;
    const pdfBytes = encoder.encode(objects.join("") + trailer);
    return new File([pdfBytes], "Blank.pdf", {type: MimeType.PDF});
}
